<mat-form-field class="flex-grow" [subscriptSizing]="data.subscriptSizing ?? 'fixed'">
  <mat-label>{{ data.label }}</mat-label>

  <input
    #autocompleteTrigger="matAutocompleteTrigger"
    #input
    (input)="autocompleteTrigger.openPanel()"
    [control]="control"
    [data]="data"
    [formControl]="control"
    [matAutocomplete]="autocompletePanel"
    matInput
    type="text"
    uiFormInputAttributes
    uiFormInputValidators
  >

  @if (control.enabled && !data.attributes?.readOnly) {
    <div matSuffix>
      @if (control.value && (control.invalid || data.options.length < 2 || autocompletePanel.isOpen)) {
        <button (click)="clearInput($event)" mat-icon-button type="button">
          <ui-icon [faName]="control.valid ? 'circle-xmark' : 'circle-exclamation'" faStyle="light"></ui-icon>
        </button>
      } @else if (data.options.length > 0) {
        <button (click)="expandMore($event)" mat-icon-button type="button">
          <ui-icon faName="expand-more" faStyle="custom"></ui-icon>
        </button>
      }
    </div>
  }

  <mat-autocomplete
    #autocompletePanel="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
    [hideSingleSelectionIndicator]="data.hideSingleSelectionIndicator"
    [requireSelection]="!data.allowArbitraryValue"
    autoActiveFirstOption
    autoSelectActiveOption
  >
    @for (option of filteredOptions$ | async; track option) {
      <mat-option [value]="option.value">
        <div class="wrapper-option">
          {{ option.label }}
          @if (option.suffix) {
            <small>{{ option.suffix }}</small>
          }
        </div>
      </mat-option>
    }
  </mat-autocomplete>

  <mat-error [control]="control" [data]="data" uiFormError></mat-error>

  @if (data.hint) {
    <mat-hint [innerText]="data.hint"></mat-hint>
  }
</mat-form-field>

@if (data.description) {
  <ui-form-input-description [description]="data.description"></ui-form-input-description>
}
